import { createStyles } from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import { tokens, Button } from "@blurb/codex-react";
import { CheckCircleIcon, ContentCopyIcon } from "@blurb/codex-react/icons";
import type { IconSize } from "@blurb/codex-react/icons";
import React from "react";

const useStyles = createStyles({
  button: {
    padding: 0,
    border: "none",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: tokens.color.semantic.bg.graySubtlerHover,
    },
  },
  icon: {
    color: tokens.color.semantic.icon.primary,
  },
});

interface CopyButtonProps {
  value: string;
  size?: IconSize;
  testId?: string;
}

/** Icon-only control that copies `value` to the clipboard, briefly swapping to a checkmark to confirm. */
export const CopyButton: React.FC<CopyButtonProps> = ({ value, size, testId }) => {
  const { classes } = useStyles();
  const clipboard = useClipboard();

  return (
    <Button
      variant="text"
      intent="neutral"
      size="small"
      aria-label={clipboard.copied ? "Copied" : "Copy"}
      data-testid={testId}
      className={classes.button}
      onClick={() => clipboard.copy(value)}
    >
      {clipboard.copied ? (
        <CheckCircleIcon className={classes.icon} size={size} />
      ) : (
        <ContentCopyIcon className={classes.icon} size={size} />
      )}
    </Button>
  );
};
